(()=>{
if(window.MOGA_NOTIFICATIONS_LOADED)return;
window.MOGA_NOTIFICATIONS_LOADED=true;

const KEY='moga_notifications_state_v9';
const byId=id=>document.getElementById(id);
const n=v=>{const x=Number(String(v??'').replace(/[^0-9,.-]/g,'').replace(',','.'));return Number.isFinite(x)?x:0};
const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'');
const today=()=>new Date().toISOString().slice(0,10);
const now=()=>Date.now();
let deleteSuccessUntil=0;

function state(){
  try{return JSON.parse(localStorage.getItem(KEY)||'{}')||{}}
  catch(e){return{}}
}
function saveState(x){
  localStorage.setItem(KEY,JSON.stringify(x||{}));
}
function tracking(){
  try{return typeof getTrackingInfo==='function'?getTrackingInfo():[]}
  catch(e){return[]}
}

function ensureUi(){
  if(byId('mogaNotificationBell'))return;

  if(!byId('mogaNotificationExtraCss')){
    const st=document.createElement('style');
    st.id='mogaNotificationExtraCss';
    st.textContent=`
      .moga-notification-tools{
        display:flex;
        gap:8px;
        align-items:center;
        flex-wrap:wrap;
      }

      .moga-notification-tools > button{
        flex:1 1 auto;
      }

      .moga-notification-delete-all{
        background:#b90000!important;
        border-color:#b90000!important;
        color:#fff!important;
      }

      .moga-notification-confirm{
        display:none;
        width:100%;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        padding:9px 10px;
        border:1px solid #e0b2b2;
        border-radius:9px;
        background:#fff5f5;
        color:#6f1717;
        font-size:11px;
        line-height:1.35;
      }

      .moga-notification-confirm.show{
        display:flex;
      }

      .moga-notification-confirm-actions{
        display:flex;
        gap:6px;
        flex:0 0 auto;
      }

      .moga-notification-confirm-actions button{
        min-width:54px;
        min-height:30px;
        border:0;
        border-radius:7px;
        font-weight:900;
        cursor:pointer;
      }

      .moga-notification-confirm-yes{
        background:#159447!important;
        border:1px solid #159447!important;
        color:#fff!important;
        font-size:18px!important;
        line-height:1!important;
      }

      .moga-notification-confirm-no{
        background:#c94343!important;
        border:1px solid #c94343!important;
        color:#fff!important;
        font-size:20px!important;
        line-height:1!important;
      }

      .moga-notification-success{
        margin:10px 12px;
        padding:12px 14px;
        border:1px solid #a9dfbd;
        border-radius:9px;
        background:#f1fbf5;
        color:#117a3c;
        font-size:12px;
        font-weight:900;
        text-align:center;
      }

      .moga-notification-item.seen{
        opacity:.58;
      }

      .moga-notification-item.seen b{
        font-weight:700;
      }

      @media(max-width:520px){
        .moga-notification-tools{
          display:grid;
          grid-template-columns:1fr 1fr;
        }

        .moga-notification-tools .moga-notification-delete-all{
          grid-column:1/-1;
        }

        .moga-notification-confirm{
          grid-column:1/-1;
        }
      }
    `;
    document.head.appendChild(st);
  }

  const btn=document.createElement('button');
  btn.id='mogaNotificationBell';
  btn.className='moga-notification-bell premium-only screen-only';
  btn.type='button';
  btn.innerHTML='<span>🔔</span><b id="mogaNotificationCount">0</b>';
  btn.onclick=toggle;

  const settings=document.getElementById('settingsBtn');
  if(settings?.parentNode)settings.parentNode.insertBefore(btn,settings);
  else document.body.appendChild(btn);

  document.body.insertAdjacentHTML('beforeend',`
    <aside id="mogaNotificationDrawer" class="moga-notification-drawer premium-only screen-only">
      <div class="moga-notification-head">
        <div>
          <div class="purchase-kicker">MOGA SF PREMIUM</div>
          <h3>PRANEŠIMAI</h3>
        </div>
        <button type="button" onclick="MOGA_NOTIFICATIONS.toggle(false)">×</button>
      </div>

      <div class="moga-notification-tools">
        <button type="button" onclick="MOGA_NOTIFICATIONS.markAllSeen()">PAŽYMĖTI PERSKAITYTA</button>
        <button type="button" onclick="MOGA_NOTIFICATIONS.clearDismissed()">ATKURTI PASLĖPTUS</button>
        <button type="button" class="moga-notification-delete-all" onclick="MOGA_NOTIFICATIONS.askDeleteAll()">IŠTRINTI VISKĄ</button>

        <div id="mogaNotificationDeleteConfirm" class="moga-notification-confirm">
          <span>Ar tikrai ištrinti visus rodomus pranešimus?</span>
          <div class="moga-notification-confirm-actions">
            <button type="button" class="moga-notification-confirm-yes" title="Taip, ištrinti viską" aria-label="Taip, ištrinti viską" onclick="MOGA_NOTIFICATIONS.deleteAll()">✓</button>
            <button type="button" class="moga-notification-confirm-no" title="Ne, atšaukti" aria-label="Ne, atšaukti" onclick="MOGA_NOTIFICATIONS.cancelDeleteAll()">×</button>
          </div>
        </div>
      </div>

      <div id="mogaNotificationList"></div>
    </aside>
  `);
  if(!byId('mogaPaymentReminderToast'))document.body.insertAdjacentHTML('beforeend',`<div id="mogaPaymentReminderToast" class="moga-payment-reminder-toast premium-only screen-only" aria-live="polite"></div>`);
}

function idFor(x){
  return `${x.type}:${x.ref||x.text}`;
}

function collect(){
  const out=[];
  const rows=tracking();

  rows.forEach(r=>{
    if((r.status||r.paid)==='Vėluoja'){
      out.push({
        type:'invoice-overdue',
        level:'danger',
        title:'Vėluojanti sąskaita',
        text:`${r.no||'SF'} · ${r.buyer||''} · ${r.sum||''}`,
        linkType:'invoice',
        ref:r.no
      });
    }
    else if((r.status||r.paid)==='Neapmokėta'&&r.date&&r.date<today()){
      out.push({
        type:'invoice-unpaid',
        level:'warn',
        title:'Neapmokėta sąskaita',
        text:`${r.no||'SF'} · ${r.buyer||''} · ${r.sum||''}`,
        linkType:'invoice',
        ref:r.no
      });
    }
  });

  const ps=window.MOGA_INVENTORY?.products?.()||[];
  ps.forEach(p=>{
    const r=window.MOGA_INVENTORY?.getRecord?.(p.inventoryId,false)||{
      qty:0,
      reserved:0,
      min:0,
      target:0
    };

    const av=n(r.qty)-n(r.reserved);
    const st=window.MOGA_INVENTORY?.status?.(p,r);

    if(st&&['low','out'].includes(st.key)){
      out.push({
        type:'stock-'+st.key,
        level:st.key==='out'?'danger':'warn',
        title:st.key==='out'?'Prekės nebėra':'Mažas prekės likutis',
        text:`${p.name} · galima ${av}${st.reason?' · '+st.reason:''}`,
        linkType:'inventory-product',
        ref:p.inventoryId
      });
    }
  });

  const po=window.MOGA_PURCHASES?.orders?.()||[];
  po.forEach(o=>{
    if(
      !['received','cancelled'].includes(o.status) &&
      o.expectedDate &&
      o.expectedDate<today()
    ){
      out.push({
        type:'purchase-late',
        level:'warn',
        title:'Vėluoja pirkimo užsakymas',
        text:`${o.no} · numatyta ${o.expectedDate}`,
        linkType:'purchase',
        ref:o.id
      });
    }
  });

  const ex=window.MOGA_EXPENSES?.load?.()||[];
  const todayMs=new Date(today()+'T00:00:00').getTime();
  ex.forEach(e=>{
    if(e.status==='paid'||!e.dueDate)return;
    const dueMs=new Date(e.dueDate+'T00:00:00').getTime();if(!Number.isFinite(dueMs))return;
    const days=Math.ceil((dueMs-todayMs)/86400000);
    if(days<=2){
      const overdue=days<0;
      out.push({
        type:'expense-due',
        level:overdue?'danger':'warn',
        title:overdue?'Pradelsta neapmokėta išlaida':days===0?'Išlaidą reikia apmokėti šiandien':`Iki apmokėjimo liko ${days} d.`,
        text:`${e.vendor||e.documentNo||'Išlaida'} · ${e.documentNo||''} · ${e.dueDate}`.replace(/ ·  · /g,' · '),
        linkType:'expense',
        ref:e.id,
        expenseReminder:true,
        dueDays:days
      });
    }
  });

  const tasks=window.MOGA_TASKS?.load?.()||[];
  tasks
    .filter(t=>t.status!=='done')
    .forEach(t=>{
      const st=window.MOGA_TASKS?.state?.(t);

      if(st==='overdue'||st==='today'){
        out.push({
          type:'task-'+st,
          level:st==='overdue'?'danger':'info',
          title:st==='overdue'?'Vėluojanti užduotis':'Užduotis šiandien',
          text:t.title,
          linkType:'task',
          ref:t.id
        });
      }
    });

  return out.map(x=>({
    ...x,
    id:idFor(x)
  }));
}

function visible(){
  const s=state();
  const dismissed=s.dismissed||{};
  return collect().filter(x=>!dismissed[x.id]);
}

function maybeShowPaymentToast(arr){
  const toast=byId('mogaPaymentReminderToast');if(!toast)return;
  const item=arr.find(x=>x.expenseReminder);if(!item){toast.classList.remove('show');return;}
  const stamp=today()+':'+item.id;
  if(sessionStorage.getItem('moga_payment_toast_seen')===stamp)return;
  sessionStorage.setItem('moga_payment_toast_seen',stamp);
  toast.innerHTML=`<button class="moga-reminder-close" onclick="document.getElementById('mogaPaymentReminderToast')?.classList.remove('show')">×</button><div class="moga-reminder-kicker">MOKĖJIMO PRIMINIMAS</div><b>${esc(item.title)}</b><span>${esc(item.text)}</span><small>Jei jau apmokėjote, atidarykite įrašą ir pakeiskite būseną į „Apmokėta“.</small><div class="moga-reminder-actions"><button onclick="MOGA_NOTIFICATIONS.openItem('${esc(item.id)}','expense','${esc(item.ref)}');document.getElementById('mogaPaymentReminderToast')?.classList.remove('show')">ATIDARYTI</button><button onclick="MOGA_NOTIFICATIONS.dismiss('${esc(item.id)}');document.getElementById('mogaPaymentReminderToast')?.classList.remove('show')">NEBEPRIMINTI APIE ŠĮ</button></div>`;
  requestAnimationFrame(()=>setTimeout(()=>toast.classList.add('show'),80));
}

function render(){
  ensureUi();

  const arr=visible();
  maybeShowPaymentToast(arr);
  const s=state();
  const seen=s.seen||{};
  const unseen=arr.filter(x=>!seen[x.id]).length;

  const c=byId('mogaNotificationCount');
  if(c){
    c.textContent=unseen;
    c.style.display=unseen?'inline-flex':'none';
  }

  const list=byId('mogaNotificationList');
  if(!list)return;

  if(deleteSuccessUntil>Date.now()){
    list.innerHTML='<div class="moga-notification-success">✓ Pranešimai ištrinti</div>';
    return;
  }

  list.innerHTML=arr.length
    ?arr.map(x=>`
      <article class="moga-notification-item ${x.level} ${seen[x.id]?'seen':''}">
        <div>
          <b>${esc(x.title)}</b>
          <span>${esc(x.text)}</span>
        </div>

        <div class="moga-notification-actions">
          ${
            x.linkType
              ?`<button onclick="MOGA_NOTIFICATIONS.openItem('${esc(x.id)}','${esc(x.linkType)}','${esc(x.ref||'')}')">ATIDARYTI</button>`
              :''
          }
          <button onclick="MOGA_NOTIFICATIONS.dismiss('${esc(x.id)}')">×</button>
        </div>
      </article>
    `).join('')
    :'<div class="purchase-empty">Naujų pranešimų nėra.</div>';
}

function toggle(force){
  ensureUi();

  const d=byId('mogaNotificationDrawer');
  if(!d)return;

  const open=
    typeof force==='boolean'
      ?force
      :!d.classList.contains('open');

  d.classList.toggle('open',open);

  if(!open){
    cancelDeleteAll();
  }

  /* Svarbu:
     vien atidarius pranešimų langą jie NEBĖRA automatiškai
     pažymimi perskaitytais. Tam skirtas atskiras mygtukas. */
}

function markAllSeen(){
  const s=state();
  s.seen=s.seen||{};

  visible().forEach(x=>{
    s.seen[x.id]=now();
  });

  saveState(s);
  render();
}

function dismiss(id){
  const s=state();
  s.dismissed=s.dismissed||{};
  s.dismissed[id]=now();

  saveState(s);
  render();
}

function clearDismissed(){
  const s=state();
  s.dismissed={};

  saveState(s);
  cancelDeleteAll();
  render();
}

function askDeleteAll(){
  const box=byId('mogaNotificationDeleteConfirm');
  if(!box)return;

  const arr=visible();

  const actions=box.querySelector('.moga-notification-confirm-actions');

  if(!arr.length){
    box.querySelector('span').textContent='Nėra ką ištrinti.';
    if(actions)actions.style.display='none';
    box.classList.add('show');

    setTimeout(()=>{
      if(box.classList.contains('show')){
        box.classList.remove('show');
        box.querySelector('span').textContent='Ar tikrai ištrinti visus rodomus pranešimus?';
        if(actions)actions.style.display='';
      }
    },1600);

    return;
  }

  if(actions)actions.style.display='';
  box.querySelector('span').textContent=`Ar tikrai ištrinti visus rodomus pranešimus? (${arr.length})`;
  box.classList.add('show');
}

function cancelDeleteAll(){
  const box=byId('mogaNotificationDeleteConfirm');
  if(!box)return;

  box.classList.remove('show');

  const txt=box.querySelector('span');
  if(txt){
    txt.textContent='Ar tikrai ištrinti visus rodomus pranešimus?';
  }

  const actions=box.querySelector('.moga-notification-confirm-actions');
  if(actions)actions.style.display='';
}

function deleteAll(){
  const arr=visible();

  if(!arr.length){
    cancelDeleteAll();
    render();
    return;
  }

  const s=state();
  s.dismissed=s.dismissed||{};

  arr.forEach(x=>{
    s.dismissed[x.id]=now();
  });

  saveState(s);
  cancelDeleteAll();

  deleteSuccessUntil=Date.now()+1300;
  render();

  setTimeout(()=>{
    deleteSuccessUntil=0;
    render();
  },1300);
}

function openItem(id,type,ref){
  const s=state();
  s.seen=s.seen||{};
  s.seen[id]=now();

  saveState(s);
  render();
  toggle(false);

  window.MOGA_LINKS?.open?.(type,ref);
}

window.MOGA_NOTIFICATIONS={
  refresh:render,
  toggle,
  markAllSeen,
  dismiss,
  clearDismissed,
  askDeleteAll,
  cancelDeleteAll,
  deleteAll,
  openItem,
  collect
};

['moga:data-ready','moga:plan-change'].forEach(ev=>{
  window.addEventListener(ev,()=>setTimeout(render,80));
});

document.addEventListener('visibilitychange',()=>{
  if(!document.hidden)render();
});

setInterval(render,60000);

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',render);
}else{
  render();
}
})();